import { defineMessages } from 'react-intl';

export const fieldMessagesRequired = defineMessages({
  gender: {
    id: 'AddressValidation.gender.required',
    defaultMessage: 'Bitte gib eine Anrede an.',
  },
  firstName: {
    id: 'AddressValidation.firstName.required',
    defaultMessage: 'Bitte gib deinen Vornamen ein.',
  },
  lastName: {
    id: 'AddressValidation.lastName.required',
    defaultMessage: 'Bitte gib deinen Nachnamen ein.',
  },
  street: {
    id: 'AddressValidation.street.required',
    defaultMessage: 'Bitte gib deine Straße ein.',
  },
  houseNumber: {
    id: 'AddressValidation.houseNumber.required',
    defaultMessage: 'Bitte gib deine Hausnummer an.',
  },
  zipCode: {
    id: 'AddressValidation.zipCode.required',
    defaultMessage: 'Bitte gib deine Postleitzahl an.',
  },
  city: {
    id: 'AddressValidation.city.required',
    defaultMessage: 'Bitte gib deinen Ort an.',
  },
});

export const fieldMessagesInvalid = defineMessages({
  firstName: {
    id: 'AddressValidation.firstName.invalid',
    defaultMessage: 'Verwende keine Sonderzeichen außer Punkt und Bindestrich.',
  },
  lastName: {
    id: 'AddressValidation.lastName.invalid',
    defaultMessage: 'Verwende keine Sonderzeichen außer Punkt und Bindestrich.',
  },
  street: {
    id: 'AddressValidation.street.invalid',
    defaultMessage: 'Verwende keine Sonderzeichen außer Punkt und Bindestrich.',
  },
  streetPackOrPost: {
    id: 'AddressValidation.street.packorpost',
    defaultMessage: 'Eine Postfiliale oder Packstation ist als Rechnungsanschrift nicht zulässig!',
  },
  houseNumber: {
    id: 'AddressValidation.houseNumber.housenumber.invalid',
    defaultMessage: 'Verwende keine Sonderzeichen außer Punkt, Bindestrich und /.',
  },
  zipCode: {
    id: 'AddressValidation.zipCode.invalid',
    defaultMessage: 'Die PLZ ist ungültig',
  },
  city: {
    id: 'AddressValidation.city.invalid',
    defaultMessage: 'Verwende keine Sonderzeichen außer Punkt und Bindestrich.',
  },
  primaryPhoneNumber: {
    id: 'AddressValidation.phone.invalid',
    defaultMessage: 'Bitte gib eine gültige Telefonnummer ein.',
  },
});

export const fieldMessagesLength = defineMessages({
  name: {
    id: 'AddressValidation.name.tooShort',
    defaultMessage: 'Zugelassene Zeichenanzahl sind 2-30 Zeichen.',
  },
  street: {
    id: 'AddressValidation.street.tooLong',
    defaultMessage: 'Die Straße darf maximal 40 Zeichen lang sein.',
  },
  city: {
    id: 'AddressValidation.city.tooLong',
    defaultMessage: 'Der Ort darf maximal 40 Zeichen lang sein.',
  },
});

export const fieldMessageGeneral = defineMessages({
  somethingWrong: {
    id: 'AddressValidation.somethingWrong',
    defaultMessage: 'Bitte überprüfe deine Eingabe.',
  },
});
